
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.756 17.15a.5.5 0 0 0-.707-.007A6.462 6.462 0 0 1 13.5 19a6.508 6.508 0 0 1-6.483-6.03A4.506 4.506 0 0 0 11 8.5V5h.5a.5.5 0 0 0 0-1H9V.5a.5.5 0 0 0-1 0V4H5V.5a.5.5 0 0 0-1 0V4H1.5a.5.5 0 0 0 0 1H2v3.5a4.506 4.506 0 0 0 4.015 4.474 7.44 7.44 0 0 0 2.182 4.829A7.45 7.45 0 0 0 13.5 20a7.456 7.456 0 0 0 5.249-2.143.5.5 0 0 0 .007-.707zM3 8.5V5h7v3.5c0 1.93-1.57 3.5-3.5 3.5S3 10.43 3 8.5z"}})])
          )
        }
      }
    